import { INotificationMessage } from "@fl/shared/src/types/messages";
import { Alert } from "react-bootstrap";

interface IProps {
  index: number;
  item: INotificationMessage;
  onUpdate: (item: INotificationMessage, index: number) => void;
}

const AlterMessageItem: React.FC<IProps> = ({ index, item, onUpdate }) => {
  const hideMessage = () => {
    const updated = { ...item };
    updated.show = false;
    onUpdate(updated, index);
  };
  return (
    <Alert
      variant={item.variant}
      show={item.show}
      onClose={hideMessage}
      dismissible
    >
      <Alert.Heading>{item.header}</Alert.Heading>
      <p>{item.message}</p>
    </Alert>
  );
};

export default AlterMessageItem;
